import { IEntitlement } from 'API/compassRights';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { ENTITLEMENT_TYPES } from 'Enum/CompassRights';
import { createContext, ReactNode, useReducer, useState } from 'react';
import { CategoriesFilterReducer } from 'reducer/CompassRights/CategoriesFilterReducer';
import { EntitlementsReducer } from 'reducer/CompassRights/EntitlementsReducer';

interface IEntitlementsContext {
  entitlements: IEntitlementsState;
  dispatchEntitlements: Function;
  categories: ICategoriesState[];
  dispatchCategories: Function;
  entitlementTypes: number[];
  setEntitlementTypes: (value: string[]) => void;
  removeEntitlementType: (value: number) => void;
}

export const EntitlementsContext = createContext<IEntitlementsContext>({
  entitlements: {
    allEntitlements: [],
    filteredEntitlements: [],
  },
  dispatchEntitlements: () => {},
  categories: [],
  dispatchCategories: () => {},
  entitlementTypes: [],
  setEntitlementTypes: () => {},
  removeEntitlementType: () => {},
});

export interface IEntitlementsState {
  allEntitlements: IEntitlement[];
  filteredEntitlements: IEntitlement[];
}

export interface ICategoriesState {
  id: number;
  name: string;
  checked?: boolean;
  subCategories: ICategory[];
}

export interface ICategory {
  id: number;
  name: string;
  checked?: boolean;
}

type Props = { children: ReactNode };

export const EntitlementsContextProvider = ({ children }: Props) => {
  const [entitlements, dispatchEntitlements] = useReducer(EntitlementsReducer, {
    allEntitlements: [],
    filteredEntitlements: [],
  });

  const [categories, dispatchCategories] = useReducer(
    CategoriesFilterReducer,
    []
  );

  const [entitlementTypes, internalSetEntitlementTypes] = useState<number[]>(
    []
  );
  const setEntitlementTypes = (labels: string[]) => {
    internalSetEntitlementTypes(
      labels.map((label) => {
        const id =
          label === Dictionary[DICTIONARY.CompassRights].entitlements.automatic
            ? ENTITLEMENT_TYPES.automatic
            : ENTITLEMENT_TYPES.singleUse;
        return id;
      })
    );
  };

  const removeEntitlementType = (value: number) => {
    internalSetEntitlementTypes(
      entitlementTypes.filter((type) => type !== value)
    );
  };

  return (
    <EntitlementsContext.Provider
      value={{
        entitlements,
        dispatchEntitlements,
        categories,
        dispatchCategories,
        entitlementTypes,
        setEntitlementTypes,
        removeEntitlementType,
      }}
    >
      {children}
    </EntitlementsContext.Provider>
  );
};
